<template>
  <page>
    <v-flex xs12>
      <form>
        <v-expansion-panel expand :value="[true]">
          <v-expansion-panel-content>
            <div slot="header">
              <v-icon>mdi-filter-variant</v-icon> Filters
            </div>
            <v-card>
              <v-card-text>
                <v-container fluid grid-list-lg>
                  <v-layout row wrap>
                    <v-flex xl3 lg4 xs6>
                      <v-text-field v-model="filters.promotion" :label="filtersLabel.promotion" :error-messages="errors.collect('promotion')" data-vv-name="promotion" :data-vv-as="filtersLabel.promotion" v-validate="'param|max:12'"></v-text-field>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <v-text-field v-model="filters.description" :label="filtersLabel.description" :error-messages="errors.collect('description')" data-vv-name="description" :data-vv-as="filtersLabel.description" v-validate="'entry|max:128'"></v-text-field>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <v-autocomplete :items="booleanList" v-model="filters.enabledB2C" :label="filtersLabel.enabledB2C" item-text="label" item-value="value" data-vv-name="enabledB2C" :data-vv-as="filtersLabel.enabledB2C" :error-messages="errors.collect('enabledB2C')" clearable></v-autocomplete>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <v-autocomplete :items="booleanList" v-model="filters.enabledB2B" :label="filtersLabel.enabledB2B" item-text="label" item-value="value" data-vv-name="enabledB2B" :data-vv-as="filtersLabel.enabledB2B" :error-messages="errors.collect('enabledB2B')" clearable></v-autocomplete>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <v-autocomplete :items="booleanList" v-model="filters.stdPromo" :label="filtersLabel.stdPromo" item-text="label" item-value="value" data-vv-name="stdPromo" :data-vv-as="filtersLabel.stdPromo" :error-messages="errors.collect('stdPromo')" clearable></v-autocomplete>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <v-autocomplete :items="booleanList" v-model="filters.usrGrpPromo" :label="filtersLabel.usrGrpPromo" item-text="label" item-value="value" data-vv-name="usrGrpPromo" :data-vv-as="filtersLabel.usrGrpPromo" :error-messages="errors.collect('usrGrpPromo')" clearable></v-autocomplete>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <v-autocomplete :items="booleanList" v-model="filters.cardPromo" :label="filtersLabel.cardPromo" item-text="label" item-value="value" data-vv-name="cardPromo" :data-vv-as="filtersLabel.cardPromo" :error-messages="errors.collect('cardPromo')" clearable></v-autocomplete>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <v-autocomplete :items="booleanList" v-model="filters.couponPromo" :label="filtersLabel.couponPromo" item-text="label" item-value="value" data-vv-name="couponPromo" :data-vv-as="filtersLabel.couponPromo" :error-messages="errors.collect('couponPromo')" clearable></v-autocomplete>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <cal-picker v-model="filters.effDate" :label="filtersLabel.effDate" :data-vv-as="filtersLabel.effDate" data-vv-name="effDate" :error-messages="errors.collect('effDate')"></cal-picker>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" flat="flat" @click.native="doClearFilters">Clear Filters</v-btn>
                <v-btn color="primary" flat="flat" type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
              </v-card-actions>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </form>
    </v-flex>
    <v-flex xs12 class="mt-3">
      <message :messages="messages"></message>
    </v-flex>
    <v-layout row wrap>
      <v-flex xs12>
        <v-layout row>
          <v-spacer></v-spacer>
          <v-menu offset-x :nudge-left="370" :close-on-content-click="false" :min-width="300" :max-height="400">
            <v-btn color="secondary" class="white--text" slot="activator">
              <span>Columns</span>
              <v-icon right dark>mdi-table-column-plus-after</v-icon>
            </v-btn>
            <v-card>
              <v-card-text>
                <template v-if="columns.length > 0">
                  <v-checkbox v-for="column in columns" :key="column.value" :label="column.text" :value="column.value" v-model="selectedColumns"></v-checkbox>
                </template>
                <template v-else>
                  No column found
                </template>
              </v-card-text>
            </v-card>
          </v-menu>
        </v-layout>
      </v-flex>
      <v-flex xs12 class="mt-2">
        <v-card>
          <v-card-title>
            <div>
              <div class="headline">Promotion Listing</div>
            </div>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-data-table v-bind:headers="listHeaders" v-bind:items="items" :total-items="totalItems" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="promotion" :loading="loading" :no-data-text="noDataText">
            <template slot="items" slot-scope="props">
              <td v-for="column in selectedColumns" :key="column">
                {{props.item[column]}}
              </td>
              <td class="text-xs-right">
                <table-action :rowData="props" query review @query="doQuery" @review="doReview(props)" remove @remove="doPromptRemove(props.item)"></table-action>
              </td>
            </template>
          </v-data-table>
        </v-card>
        <div class="pt-2">
          <v-btn color="primary" @click="doNew">
            Add New Promotion
            <v-icon right>mdi-playlist-plus</v-icon>
          </v-btn>
        </div>
        <confirm v-model="promptRemove" @ok="doRemove">
          Are you sure that you want to delete the selected Promotion?
          <div class="title">{{deletePromotion}}</div>
        </confirm>
      </v-flex>
    </v-layout>
  </page>
</template>

<script>
import clone from 'clone'
import toDate from 'date-fns/toDate'
import { mapGetters } from 'vuex'
import { expandURI, filterQuery } from '@/utils/ajax'
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { removeTime, formatDisplayDate, formatDisplayDateTime2 } from '@/utils/date'

export default {
  data() {
    return {
      columns: [
        { text: 'Promotion Code', align: 'left', value: 'promotion' },
        { text: 'Promotion Description', value: 'description' },
        { text: 'Effective Date', value: 'effDate' },
        { text: 'Expiry Date', value: 'endDate' },
        { text: 'Enabled for B2C', value: 'enabledB2C' },
        { text: 'Enabled for B2B', value: 'enabledB2B' },
        { text: 'Standard', value: 'stdPromo' },
        { text: 'User Group', value: 'usrGrpPromo' },
        { text: 'Credit Card', value: 'cardPromo' },
        { text: 'Coupon', value: 'couponPromo' },
        { text: 'Created Date', value: 'createdDate' }
      ],
      selectedColumns: ['promotion', 'description', 'effDate', 'endDate', 'enabledB2C', 'enabledB2B', 'createdDate'],
      totalItems: 0,
      filters: {
        promotion: null,
        description: null,
        effDate: null,
        enabledB2C: null,
        enabledB2B: null,
        stdPromo: null,
        usrGrpPromo: null,
        cardPromo: null,
        couponPromo: null
      },
      filtersLabel: {
        promotion: 'Promotion Code',
        description: 'Promotion Description',
        effDate: 'Effective Date',
        enabledB2C: 'Enabled for B2C',
        enabledB2B: 'Enabled for B2B',
        stdPromo: 'Standard Promotion',
        usrGrpPromo: 'User Group Promotion',
        cardPromo: 'Credit Card Promotion',
        couponPromo: 'Coupon Promotion'
      },
      booleanList: [
        { label: 'Yes', value: true },
        { label: 'No', value: false }
      ],
      promptRemove: false,
      selectedPromotion: undefined,
      deletePromotion: ''
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    listHeaders() {
      let result = []
      for (const selectedColumn of this.selectedColumns) {
        let findCol = this.columns.find(a => selectedColumn === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      result.push(TableConst.tableActionHeader)
      return result
    }
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination.descending': function (value) {
      this.fetchData(false)
    },
    'pagination.page': function (value) {
      this.fetchData(false)
    },
    'pagination.rowsPerPage': function (value) {
      this.fetchData(false)
    },
    'pagination.sortBy': function (value) {
      this.fetchData(false)
    }
  },
  methods: {
    async fetchData(options) {
      const apiUrl = this.$store.state.promotionManagement.menu.promotionList
      if (apiUrl) {
        try {
          this.loading = true
          const { page, rowsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: rowsPerPage,
            options: options
          }
          // Massage the filters
          let massageFilters = clone(this.filters)
          if (massageFilters.effDate) {
            massageFilters.effDate = formatDisplayDateTime2(removeTime(massageFilters.effDate))
          }
          const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), massageFilters, this.pagination.sortBy, this.pagination.descending))
          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            if (data) {
              // Format the data here
              this.items = []
              data.map((promotion) => {
                const convertPromotion = {
                  promotion: promotion.promotion,
                  description: promotion.description,
                  effDate: this.formatDateTime2(toDate(promotion.effDate)),
                  endDate: this.formatDateTime2(toDate(promotion.endDate)),
                  enabledB2C: this.formatBoolean(promotion.enabledB2C),
                  enabledB2B: this.formatBoolean(promotion.enabledB2B),
                  stdPromo: this.formatBoolean(promotion.stdPromo),
                  usrGrpPromo: this.formatBoolean(promotion.usrGrpPromo),
                  cardPromo: this.formatBoolean(promotion.cardPromo),
                  couponPromo: this.formatBoolean(promotion.couponPromo),
                  createdDate: this.formatDate(toDate(promotion.createdDate))
                }
                this.items.push(convertPromotion)
              })
            } else {
              this.items = []
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fullMessage(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    doQuery(data) {
      if (data && data.item && data.item.promotion) {
        this.$router.push({ name: 'promotionQuery', params: { promotion: data.item.promotion } })
      }
    },
    doReview(data) {
      if (data && data.item && data.item.promotion) {
        this.$router.push({ name: 'promotionReview', params: { promotion: data.item.promotion } })
      }
    },
    doNew() {
      this.$router.push({ name: 'promotionReview', params: { promotion: 'New' } })
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedPromotion = data
        this.deletePromotion = data.promotion + ' - ' + data.description
      }
    },
    async doRemove() {
      const apiURI = this.$store.state.promotionManagement.menu.promotionDelete
      if (apiURI) {
        this.loading = true
        const expand = {
          promotion: this.selectedPromotion.promotion
        }
        try {
          const result = await this.$http.delete(expandURI(apiURI, expand))
          this.notify(result.data)
          // Reinit
          this.fetchData()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    doClearFilters() {
      this.filters.promotion = null
      this.filters.description = null
      this.filters.effDate = null
      this.filters.enabledB2C = null
      this.filters.enabledB2B = null
      this.filters.stdPromo = null
      this.filters.usrGrpPromo = null
      this.filters.cardPromo = null
      this.filters.couponPromo = null
      this.fetchData(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          // Reset to page 1
          this.pagination.page = 1
          this.fetchData(false)
        }
      })
    },
    formatDate(date) {
      return formatDisplayDate(date)
    },
    formatDateTime2(dateTime) {
      return formatDisplayDateTime2(dateTime)
    }
  },
  created() {
    this.fetchData(true)
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style lang="scss">
</style>
